import { VisualizationTypes } from '@shared/enums';

export const VISUALIZATION_WITH_GOAL_FIELD = [
  VisualizationTypes.Pareto,
  VisualizationTypes.Donut
];

export const TILE_NAME_MAX_LENGTH = 64;
